import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, Subscription } from 'rxjs';
import { KieneAutocompleteComponent } from '../../../../../../../../src/app/components/kiene-autocomplete/kiene-autocomplete.component';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Client } from '../../../client/classes/client';
import { ConfirmDialogInput } from '../../../dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../dialogs/confirm-dialog/confirm-dialog.component';
import {
    MeineKontakteDialogInput,
    MeineKontakteDialogResult,
} from '../../../meine-kontakte/meine-kontakte-dialog/meine-kontakte-dialog';
import { MeineKontakteDialogComponent } from '../../../meine-kontakte/meine-kontakte-dialog/meine-kontakte-dialog.component';
import { Betriebsart, Produktionsabschnitt } from '../../../stammdaten/vvvo/classes/betriebsart';
import { Gruppe } from '../../classes/gruppe';

@Component({
    selector: 'kiene-gruppe-schwein-form',
    standalone: false,
    templateUrl: './gruppe-schwein-form.component.html',
    styleUrls: ['./gruppe-schwein-form.component.scss'],
})
export class GruppeSchweinFormComponent implements OnInit {
    @ViewChild('standortAutocomplete') standortAutocomplete: KieneAutocompleteComponent;
    @Input('input') input: Gruppe;
    @Input() showAnzahlDatumGewicht!: boolean;
    @Output() changeAttributes = new EventEmitter<any>();

    params = new HttpParams();
    gruppennameCtrl = new FormControl(undefined, [Validators.required]);

    anzahlTiereCtrl = new FormControl(undefined, [Validators.required]);
    einstalldatumVonCtrl = new FormControl(undefined, [Validators.required]);
    einstallgewichtProTierCtrl = new FormControl();
    abteilCtrl = new FormControl();

    stall: string;
    produktionsabschnittCtrl = new FormControl<Produktionsabschnitt>(undefined, [Validators.required]);
    produktionsabschnitte: Produktionsabschnitt[] = [];

    produktionsabschnittSub: Subscription;
    kundeHerkunft: Client;
    isSaving = false;
    isMobile = false;

    constructor(
        @Inject(API_BASE_URL_SERVICE) public apiBaseUrl: string,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private appService: AppService,
        private messageService: MessageService,
    ) {}

    showAbschnittStallAbteil(): boolean {
        return this.input?.gruppe_id <= 0;
    }

    ngOnInit(): void {
        console.log('GruppeSchweinFormComponent ngOnInit', this.input);
        this.isMobile = this.appService.isMobileScreen;
        this.gruppennameCtrl.setValue(this.input?.bezeichnung, { emitEvent: false });
        this.anzahlTiereCtrl.setValue(Number(this.input?.anzahl_tiere_aktuell), { emitEvent: false });

        // TODO:
        //if (this.input?.produktionsabschnitt) {
        //    this.produktionsabschnittCtrl.setValue(this.input.produktionsabschnitt);
        //}

        this.abteilCtrl.setValue(this.input?.abteil, { emitEvent: false });
        this.stall = this.input?.stall;

        this.einstalldatumVonCtrl.setValue(this.input?.einstalldatum_von, { emitEvent: false });
        this.einstallgewichtProTierCtrl.setValue(this.input?.einstall_gewicht, { emitEvent: false });

        if (this.input?.kunde_id) {
            this.params = this.params.set('kunde_id', this.input?.kunde_id);

            this.loadGruppennamenUndAufstalleinheitVorschlag();
            this.ladeProduktionsabschnitte();
        } else {
            this.messageService.alertMessage('Es wurde kein Kunde übergeben!');
        }

        this.ladeProduktionsabschnitte();

        this.subscribeToChanges();
    }

    ladeProduktionsabschnitte() {
        if (this.input?.betriebsart_id) {
            this.produktionsabschnittSub?.unsubscribe();
            this.produktionsabschnittSub = this.api
                .getByIdAlternative(
                    this.apiBaseUrl + 'betriebsart/read_one.php',
                    'betriebsart_id',
                    this.input?.betriebsart_id,
                )
                .subscribe({
                    next: (betriebsart: Betriebsart) => {
                        this.produktionsabschnitte = betriebsart.produktionsabschnitte;
                        if (this.produktionsabschnitte?.length === 1) {
                            this.produktionsabschnittCtrl.setValue(this.produktionsabschnitte[0]);
                        }
                    },
                    error: err => {
                        this.messageService.errorMessage('Produktionsabschnitte konnten nicht geladen werden!', err);
                    },
                });
        }
    }

    produktionsabschnittComparator(a: Produktionsabschnitt, b: Produktionsabschnitt): boolean {
        return a?.produktionsabschnitt_id === b?.produktionsabschnitt_id;
    }

    loadGruppennamenUndAufstalleinheitVorschlag() {
        if (!this.input?.bezeichnung && this.input?.kunde_id) {
            this.api
                .getByIdAlternative(this.apiBaseUrl + 'gruppe/read_vorschlag.php', 'kunde_id', this.input?.kunde_id)
                .subscribe(response => {
                    if (response) {
                        this.gruppennameCtrl.setValue(response?.bezeichnung);
                    }
                });
        }
    }

    setStandort(standort) {
        if (typeof standort === 'object' && standort?.stall) {
            this.stall = standort.stall;
        } else if (typeof standort === 'string' && standort) {
            this.stall = standort;
        } else {
            console.log(standort);
        }
        this.emitChanges();
    }

    deleteStall(gruppe: Gruppe) {
        const input = new ConfirmDialogInput();
        input.headline = 'Stall löschen';
        input.text = 'Wollen Sie den Stall wirklich löschen?';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result.ok) {
                        this.deleteStallConfirmed(gruppe);
                    }
                },
            });
    }

    public openHerkunftsBetriebDialog(): void {
        let input = new MeineKontakteDialogInput('Herkunftsbetrieb', false, true, false, this.input?.kunde_id);

        this.dialog
            .open(MeineKontakteDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: MeineKontakteDialogResult) => {
                    if (result?.kunde) {
                        this.kundeHerkunft = result.kunde;
                        this.emitChanges();
                    }
                },
            });
    }

    deleteHerkunftsbetrieb() {
        this.kundeHerkunft = null;
        this.emitChanges();
    }

    emitChanges(): void {
        this.input.bezeichnung = this.gruppennameCtrl.value;
        this.input.anzahl_tiere = this.anzahlTiereCtrl.value;
        this.input.abteil = this.abteilCtrl.value;
        this.input.stall = this.stall;
        this.input.kunde_id_herkunft = this.kundeHerkunft?.kunde_id;
        this.input.kunde_herkunft = this.kundeHerkunft?.bezeichnung;
        this.input.einstalldatum_von = this.einstalldatumVonCtrl.value;
        this.input.einstall_gewicht = this.einstallgewichtProTierCtrl.value;
        const prodAbschnitt = this.produktionsabschnittCtrl.value;

        if (prodAbschnitt) {
            this.input.produktionsabschnitt_id = prodAbschnitt.produktionsabschnitt_id;
        } else {
            this.input.produktionsabschnitt_id = null;
        }

        this.input.kunde_id_herkunft = this.kundeHerkunft?.kunde_id;

        this.changeAttributes.emit(this.input);
    }

    private subscribeToChanges(): void {
        this.gruppennameCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
        this.anzahlTiereCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
        this.einstalldatumVonCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
        this.einstallgewichtProTierCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
        this.abteilCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
        this.produktionsabschnittCtrl.valueChanges.pipe(debounceTime(333)).subscribe(() => this.emitChanges());
    }

    private deleteStallConfirmed(gruppe: Gruppe): void {
        this.api.deleteGeneric(this.apiBaseUrl + 'gruppe/delete_stall.php', gruppe).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Standort wurde erfolgreich gelöscht!');
                this.standortAutocomplete.clearAndFocus();
            },
            error: error => {
                this.messageService.errorMessage('Der Standort konnte nicht gelöscht werden', error);
            },
        });
    }
}
